<template>
    <div class="">
        <div class="flex">
            <span class="font-bold mt-5 mr-5">Puntaje Total Preguntas: {{ sumarPuntaje }}</span>
            <!--CUANTO EL PUNTAJE DE PUNTAJES SOBREPASA EL PUNTAJE CONFIGURADO-->
            <div v-if="sumarPuntaje > ObjectSelected.puntaje && listado == 1">
                <vs-chip color="dark" class="mt-5" transparent>
                    <p><i class="fa-solid fa-circle-exclamation"></i> Advertencia El puntaje total de la preguntas es mayor de <b>{{ ObjectSelected.puntaje }}</b> configurado</p>
                </vs-chip>
                <br><br>
            </div>
            <!--CUANDO EL PUNTAJE DE PREGUNTAS  ES MENOR OSEA FALTA PREGUNTAS PARA LLEGAR AL CONFIGURADO-->
            <div v-if="sumarPuntaje < ObjectSelected.puntaje && listado == 1">
                <vs-chip color="primary" class="mt-5" transparent>
                    <p><i class="fa-solid fa-circle-exclamation"></i> Advertencia: El puntaje total de la preguntas es menor de <b>{{ ObjectSelected.puntaje }}</b> configurado</p>
                </vs-chip>
                <br><br>
            </div>
        </div>
        <vs-table stripe :data="listaPreguntas" no-data-text="No hay preguntas de este tema" class="mt-2" search>
        <template slot="header">
            <vs-chip>Cantidad: {{ listaPreguntas.length }}</vs-chip>
        </template>
        <template slot="thead">
            <vs-th sort-key="pregunta">Pregunta</vs-th>
            <vs-th sort-key="id_tipo_pregunta">Opciones</vs-th>
            <vs-th v-if="acciones == 1">Acciones</vs-th>
        </template>
        <template slot-scope="{data}">
            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                <vs-td :data="data[indextr].nombre_unidad">
                    <p>#{{ tr.id }}</p>
                    <p v-if="btnAsignar == 0"><b>Grupo:</b> <span> {{ tr.grupo }}</span></p>
                    <p><b>Tipo:</b> <span> {{ tr.nombreTipo }}</span></p>
                    <b>Unidad:</b>
                    <p>Unidad {{ tr.unidad }} - {{ tr.nombre_unidad }}</p>
                    <b>Pregunta:</b>
                    <p class="text-success font-bold">{{ tr.pregunta }}</p>
                    <p><b>Puntaje:</b><span> {{ tr.puntaje }}</span></p>
                    <p> <vs-chip v-if="tr.estado == 1" color="success">Activa</vs-chip> <vs-chip v-if="tr.estado == 0">Inactiva</vs-chip> </p>
                    <br>
                    <img v-if="tr.url!='' && tr.url!='null' && tr.url!=null" :src="$data_book+'archivos/'+'preguntas'+'/'+tr.url" class="img-responsive mt-5" width="80" height="80" style="border-radius: 5px;">
                </vs-td>
                <vs-td :data="tr.nombre_unidad">
                    <!---si es columna-->
                    <div v-if="tr.id_tipo == 5">
                        <table class="padding:10px;" v-if="tr.opciones.length > 0">
                            <tr>
                                <th>{{ tr.columna1 }}</th>
                                <th>{{ tr.columna2 }}</th>
                            </tr>
                            <tr v-for="(item, indexitem) in tr.opciones" :key="indexitem" >
                                <td><b>{{ indexitem + 1 }}.</b> {{ item.respuesta }}</td>
                                <td><b> {{ String.fromCharCode(97 + indexitem) }}) </b>{{ item.caracteristica }}</td>
                            </tr>
                        </table>
                    </div>
                    <div v-else>
                        <div class="mb-5" :key="indexitem" v-for="(item, indexitem) in tr.opciones">
                            <div style="width: 100%; font-size: 12px; color: #0DCD88;" class="mt-2" v-if="item.opcion=='true'">Respuesta correcta<br></div>
                            <div style="width: 100%; font-size: 12px; color: #FD5858;" v-else>Respuesta incorrecta<br></div>
                            <div style="width: 100%"> {{ item.respuesta }}<br></div>
                            <div style="width: 100%"><img v-if="item.url!='' && item.url!='null' && item.url!=null" :src="$data_book+'archivos/'+'opcion_preguntas'+'/'+item.url" class="img-responsive m-3" width="80" height="80" style="border-radius: 5px;">
                            </div>
                        </div>
                    </div>
                </vs-td>
                <vs-td v-if="acciones == 1">
                    <vs-button v-if="btnAsignar == 1"  @click="asignarPregunta(tr)" color="success" icon="add">Asignar Pregunta</vs-button>
                    <vs-button v-if="btnquitar  == 1"  @click="openConfirmDelete(tr)" color="danger" icon="delete">Quitar</vs-button>
                </vs-td>
            </vs-tr>
        </template>
    </vs-table>
    </div>
</template>
<script>
export default{
    props:{
        listaPreguntas:{
            type: Array,
            required: true,
            default: () => []
        },
        acciones:{
            type: Number,
            default: 0
        },
        btnAsignar:{
            type: Number,
            default: 0
        },
        btnquitar:{
            type: Number,
            default: 0
        },
        listado:{
            type:Number,
            default:0,
        },
        ObjectSelected:{
            type:Array,
            default:() => []
        }
    },
    watch:{
        listaPreguntas(results){
            this.listaPreguntas = results;
        }
    },  
    computed:{
        sumarPuntaje(){
            let total = 0;
            this.listaPreguntas.forEach((pregunta) => {
                total += pregunta.puntaje;
            });
            return total;
        },
    },
    methods:{
        asignarPregunta(pregunta){
            this.$emit('asignarPregunta', pregunta);
        },
        openConfirmDelete(pregunta){
            this.$emit('openConfirmDelete', pregunta);
        },
    }
}
</script>